export const getTodayDate = () => {
  const date = new Date();

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getYesterdayDate = () => {
  const date = new Date();
  date.setDate(date.getDate() - 1);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const disabledStatuses = [
  "CANDIDATE_SUBMITTED",
  "VERIFICATION_IN_PROGRESS",
  "VERIFIED",
  "STOPPED",
  "OUT_OF_SCOPE",
  "CANCELLED",
  "MAJOR_DISCREPANCY",
  "MINOR_DISCREPANCY",
  "UNABLE_TO_VERIFY",
  "NA",
  "WORK IN PROGRESS",
  "SUBMITED",
];
